import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useRequisitionList() {
    // Use toast
    const toast = useToast()

    const refReqActiveListTable = ref(null)

    // Table Handlers
    const tableColumns = [
        // { key: 'All', sortable: true },
        { key: 'sl', sortable: true },
        // { key: 'type', sortable: true },
        { key: 'type', label: 'title', sortable: true },
        { key: 'details', label: 'details', sortable: false },
        { key: 'created_at', label: 'date', sortable: true },
        { key: 'status', sortable: false },
        { key: 'actions' },
    ]

    const perPage = ref(10)
    const totalRecruitments = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('notifications.id')
    const isSortDirDesc = ref(false)

    const companyFilter = ref(null)
    const unitFilter = ref(null)
    const functionFilter = ref(null)
    const departmentFilter = ref(null)
    const sectionFilter = ref(null)
    const designationFilter = ref(null)
    const rankFilter = ref(null)
    const locationFilter = ref(null)
    const districtFilter = ref(null)
    const thanaFilter = ref(null)
    const statusFilter = ref(null)

    const dataMeta = computed(() => {
        const localItemsCount = refReqActiveListTable.value ? refReqActiveListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalRecruitments.value,
        }
    })

    const refetchData = () => {
        refReqActiveListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, companyFilter, unitFilter, designationFilter, functionFilter, departmentFilter, sectionFilter, designationFilter, rankFilter, locationFilter, districtFilter, thanaFilter, statusFilter], () => {
        refetchData()
    })

    const fetchActiveRequisitions = (ctx, callback) => {
        store
            .dispatch('notificationStore/fetchActiveNotificationData', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,

                company_id: companyFilter.value,
                unit_id: unitFilter.value,
                function_id: functionFilter.value,
                department_id: departmentFilter.value,
                section_id: sectionFilter.value,
                designation_id: designationFilter.value,
                rank_id: rankFilter.value,
                job_location_id: locationFilter.value,
                district_id: districtFilter.value,
                sub_district_id: thanaFilter.value,
                status: statusFilter.value,

                tab_name: 'Active',

            })
            .then(response => {
                const Requisitions = response.data.data
                console.log(response.data.data)
                const { total } = response.data

                callback(Requisitions)
                totalRecruitments.value = total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching recruitment list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    return {
        fetchActiveRequisitions,
        tableColumns,
        perPage,
        currentPage,
        totalRecruitments,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refReqActiveListTable,
        refetchData,

        // Extra Filters
        companyFilter,
        unitFilter,
        functionFilter,
        departmentFilter,
        sectionFilter,
        designationFilter,
        rankFilter,
        locationFilter,
        districtFilter,
        thanaFilter,
        statusFilter,
    }
}
